import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';

@Injectable()
export class ValidatorService {
 

  constructor(private httpClient: HttpClient) {
  }

  asyncCheckIfPasswordWeak = (control: FormControl) => {

    return new Promise(
      (resolve, reject) => {
        const value = control.value;
        if (control.value == null || control.value == undefined || control.value.length == 0)
          resolve(null);

        this.checkIfPasswordWeak(value).subscribe(response => {

          if (!response)
            resolve(null);
          else
            resolve({ weakPassword: true });
        });
      }
    );

  }
  checkIfPasswordWeak(password: any): Observable<any> {
    return  this.httpClient.post('/auth/checkIfPasswordWeak',{password} );
  }

}
